export default {
	'business-data-search': {
		id: 'business-data-search',
		label: '营业数据查询',
		code: '0006_0002',
		child: {
			'see-un-sync': {
				id: 'see-un-sync',
				label: '查看未同步数据',
				code: '0006_0002_090_001'
			},
			're-import': {
				id: 're-import',
				label: '重新导入营业数据',
				code: '0006_0002_030_005'
			},
			'get-business-data': {
				id: 'get-business-data',
				label: '立即获取营业数据',
				code: '0006_0002_095_001'
			}
		}
	}
}
